// extracted by mini-css-extract-plugin
export default {"container":"HeaderTerminal_container__ddGZt","header-container":"HeaderTerminal_header-container__rdrtl"};